/** The alert carries no data of its own: it is shown while the Outcome is Failed and neither end date is registered. */
export const DetailDescriptionEmployeeAlertProbationFailedStillEmployed = () => (
  <>
    <div>Probation outcome: Failed</div>
    <div>Employment end date and Last working date: not registered</div>
  </>
);
